// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1kyIz","title":"Header_title__mA9xn","side":"Header_side__ZTkxy"};